<template>
    <div class="container py-5">
        <div class="row justify-content-center">
            <div class="col-lg-10">
                <div
                    class="row g-4 align-items-center p-4 bg-white shadow-sm border-bottom border-danger border-5"
                >
                    <!-- Text Section -->
                    <div class="col-12">
                        <h1 class="mb-5">Something went wrong.</h1>

                        <p class="mb-4">
                            <strong
                                >We could not create your account. </strong
                            >
                            But don't worry we can fix it. Just get in touch with your King's Trust team member. Or contact us.
                        </p>

                        <a
                            href="https://www.kingstrust.org.uk/contact-us"
                            class="btn btn-primary px-4"
                            target="_blank"
                            rel="noopener"
                        >
                            Need help? Contact us
                        </a>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>